module.exports = "https://static.wmbcdn.com/uniweb/images/0fbaa94c4e3325a4ac596bdc65a4170d.svg";